function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("mask", {
  id: "check_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 1,
  y: 1,
  width: 14,
  height: 14
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.333 8A6.67 6.67 0 018 1.333 6.67 6.67 0 0114.667 8 6.67 6.67 0 018 14.667 6.67 6.67 0 011.333 8zm2 0l3.334 3.333 6-6-.94-.946-5.06 5.06L4.274 7.06l-.94.94z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#check_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#81D89F",
  d: "M0 0h16v16H0z"
}));

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCheck;